<template>
    <p>{{status}}</p>
</template>


<script>
export default {
    name: 'UpdatesStatus',
    props: {
        spots: Array,
    },
    computed:{
        status(){
            const postedUpdatesCount = this.spots && this.spots.filter(spot => spot && spot.posted).length;
            const spotsWithCampaignsCount = this.spots && this.spots.filter(spot => spot && spot.uid).length
            return `${postedUpdatesCount}/${spotsWithCampaignsCount} posted`
        }
    }
}
</script>